import React, { Component } from 'react'
import {json, Link, Navigate, useNavigate} from 'react-router-dom'
import navstyle from '../Styles/Navbar.css'
import logo from '../Assest/brokerlogo.jpg';
class Nav extends Component
{
   
    state = {clicked:false};

    handleClickbar=()=>
    {
       
      this.setState(
        {
            clicked:!this.state.clicked
        }
      )  
    }
     
    tempload =()=>
    {
        const nav = useNavigate();
        nav('/');
    }
    render()
    {
        const auth = localStorage.getItem('user');
        //LOGOUT FUNCTION   
        const logout = ()=>
        {
            
            localStorage.clear();
            console.warn("LOGGED OUT");
            this.tempload();
        }
        //brand click
    return(
        <div className='navbar1'>
            <div className='brandn'>
                <Link to="/" className ='item'><img src={logo}/>Bech<span>Naa</span></Link>
            </div>
            <ul id='menuitems' className={this.state.clicked ? "#menuitems active" : "#menuitems" }>
                <li ><Link className='item' to= "/buy" onClick={this.handleClickbar}>Buy</Link></li>
                <li ><Link className='item' to= "/sell"onClick={this.handleClickbar}> Sell</Link></li>
                <li ><Link className='item' to= "/contactus"onClick={this.handleClickbar}>Contact us</Link></li>
                <li >{auth? <Link className='item' onClick={logout} to= "/">Logout( {JSON.parse(auth).name} )</Link>  : 
                    <Link className='item' to= "/signup">Login</Link>}</li>
            </ul>
            <div id='mobile' onClick={this.handleClickbar}>
               <i id= "bar" className={this.state.clicked ? 'fas fa-times' : 'fas fa-bars'}></i>
            </div>
    
        </div>
       
    )
}
     
}
export default Nav;